// Доменные сущности. SPEC shared-contracts §4.4 (с правкой M: role→title).
/**
 * Канонический предел длины `Message.text` в символах (аддитивно, R2). Значение по умолчанию для
 * серверного инварианта messaging (конфиг CC-1 `maxTextLen` может переопределить) и для клиентской
 * проверки до отправки. Без предела один вставленный дамп (реальный случай: 11 МБ CSV) валил
 * рендер у всех участников чата и раздувал каждую выдачу истории.
 */
export const MESSAGE_TEXT_MAX = 8192;
/**
 * Same-origin путь аватара пользователя (раздаёт api-server GET /users/:id/avatar под auth, R2).
 * Канон здесь, потому что путь строят ДВА владельца проекций (identity → SelfUser, directory →
 * PublicUser): presigned-URL на внутренний STORAGE_ENDPOINT снаружи недоступен (урок media W10).
 * `version` — cache-busting (обычно updated_at в мс): ключ объекта у пользователя стабильный.
 */
export function userAvatarPath(id, version) {
    const v = version === undefined ? '' : `?v=${encodeURIComponent(String(version))}`;
    return `/users/${id}/avatar${v}`;
}
//# sourceMappingURL=entities.js.map